import ExtendableError from 'extendable-error-class';

export const DEFAULT_ERROR_MESSAGE =
  'It looks like something went wrong. If the problem persists, please contact <a href="mailto:support@ludus.one">support@ludus.one</a>.';
export const CRITICAL_ERROR_MESSAGE =
  'Something went definitely wrong. Click OK to try refreshing the page. If the problem persists, please contact <a href="mailto:support@ludus.one">support@ludus.one</a>.';

/**
 * Abstract base class for custom errors
 *
 */
class BaseError extends ExtendableError {
  constructor(message, title) {
    super(message);
    this.title = title || 'Oops';
    this.alertMessage = DEFAULT_ERROR_MESSAGE;
  }
}

/**
 * Custom error class for upgrade-related errors
 *
 */
export class UpgradeError extends BaseError {
  constructor(message, title, isTeam) {
    super(message, title);
    this.log = false;
    this.report = false;
    this.reload = false;
    this.notify = false;
    this.alert = true;
    this.alertMessage = message;
    this.isTeam = isTeam;
  }
}

/**
 * Custom error class for user-provoked errors
 *
 */
export class UserError extends BaseError {
  constructor(message, title) {
    super(message, title);
    this.log = false;
    this.report = false;
    this.reload = false;
    this.notify = false;
    this.alert = true;
    this.alertMessage = message;
  }
}

export class OutdatedVersionError extends BaseError {
  constructor(message, title) {
    super(message, title);
    this.log = false;
    this.report = false;
    this.reload = false;
    this.notify = true;
    this.notificationType = 'default';
    this.alert = false;
    this.alertMessage = message;
  }
}

/**
 * Custom error class for system-provoked errors
 *
 */
export class SystemError extends BaseError {
  constructor(message, title) {
    super(message, title);
    this.log = true;
    this.report = false;
    this.reload = false;
    this.notify = false;
    this.alert = true;
    this.alertMessage = message;
  }
}

/**
 * Custom error class for technical, recoverable errors that should be handled silently
 *
 */
export class TechnicalError extends BaseError {
  constructor(message, title, options) {
    super(message, title);
    this.log = true;
    this.report = true;
    this.reload = false;
    this.notify = false;
    this.alert = false;
    this.alertMessage = message;
    this.options = options;
  }
}

/**
 * Custom error class for critical, unrecoverable errors that should ask for app reload
 *
 */
export class CriticalError extends BaseError {
  constructor(message, title) {
    super(message, title);
    this.log = true;
    this.report = true;
    this.reload = true;
    this.notify = false;
    this.alert = true;
    this.alertMessage = CRITICAL_ERROR_MESSAGE;
  }
}
